import React, { useEffect, useState } from 'react'
import UserRatingsTabular from '../../Children/Tabular/UserRatingsTabular';
import UserRatingsGraphical from '../../Children/Graphical/UserRatingsGraphical';
import CustomButton from '../../../../../../../Common/CustomButton/CustomButton';
import { showAlert } from '../../../../../../../../Assests/Utility';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import { AppConstant } from '../../../../../../../../Assests/AppConstant';
import { calculateMonthDifference } from '../../../../../../../../../Utils/DateUtils';
import DownloadSectionBE from '../../../../../DownloadSection/DownloadSectionBE';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { useSelector } from 'react-redux';
import moment from 'moment';

const UserRatingsWrapper = (props) => {
  const dispatch = useDispatch()
  const [view, setView] = useState('T');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [IDWarehouse, setIDWarehouse] = useState("ALL");
  const userObj = useSelector(getUserSelector);
  const { selectedWarehouse, cu_id, userType, userAccountDetails } = userObj;
  const [currentFilterSelected, setCurrentFilterSelected] = useState({ name: 'All' });

  const [isError, setIsError] = useState(false)

  /**
   * Used to set the current date and year details
   */
  useEffect(() => {
    const dStart = new Date()
    const dEnd = new Date()
    dEnd.setUTCHours(23, 59, 59, 999);
    setStartDate(new Date(dStart.getFullYear(), dStart.getMonth(), 1));
    setEndDate(new Date(dEnd.getFullYear(), dEnd.getMonth() + 1, 0))
  }, [])

  /**
   * Used to validate the start year difference, if it doesn't match it throws error
   * @param {*} year 
   */
  const handleStartYearChange = (year) => {

    const newStartDate = new Date(year, startDate.getMonth(), 1);
    if (newStartDate > endDate) {
      showAlert(toast.TYPE.ERROR, AppConstant.reports.userRatings.startGreaterThanEndError, 'light')
      setIsError(true)
      // return;
      // setEndDate(newStartDate);
    } else if (calculateMonthDifference(newStartDate, endDate) > 2) {
      showAlert(toast.TYPE.ERROR, AppConstant.reports.userRatings.dateDiffGreaterThan12Months, 'light')
      setIsError(true)
      // return;
      // setEndDate(newStartDate);
    } else {
      setIsError(false)
    }
    setStartDate(newStartDate);
  };

  /**
      * Used to validate the end year difference, if it doesn't match it throws error
      * @param {*} year 
      */
  const handleEndYearChange = (year) => {
    const newEndDate = new Date(year, endDate.getMonth() + 1, 0);
    newEndDate.setMonth(newEndDate.getMonth() + 1, 0);
    if (newEndDate < startDate) {
      showAlert(toast.TYPE.ERROR, AppConstant.reports.userRatings.endGreaterThanStartError, 'light')
      setIsError(true)
      // return;
      // setStartDate(newEndDate);
    } else if (calculateMonthDifference(startDate, newEndDate) > 2) {
      showAlert(toast.TYPE.ERROR, AppConstant.reports.userRatings.dateDiffGreaterThan12Months, 'light')
      setIsError(true)
      // return;
      // setStartDate(newEndDate);
    } else {
      setIsError(false)
    }
    setEndDate(newEndDate);
  };

  /**
* Used to validate the start date difference, if it doesn't match it throws error
* @param {*} year 
*/
  const handleStartDateChange = (date) => {
    if (date > endDate) {
      showAlert(toast.TYPE.ERROR, AppConstant.reports.userRatings.startGreaterThanEndError, 'light')
      setIsError(true)
      // return;
      // setEndDate(date);
    } else if (calculateMonthDifference(date, endDate) > 2) {
      showAlert(toast.TYPE.ERROR, AppConstant.reports.userRatings.dateDiffGreaterThan12Months, 'light')
      setIsError(true)
      // return;
      // setEndDate(date);
    } else {
      setIsError(false)
    }

    date.setDate(1);
    setStartDate(new Date(date.getFullYear(), date.getMonth(), 1));
  };

  /**
   * Used to validate the end date difference, if it doesn't match it throws error
   * @param {*} year 
   */
  const handleEndDateChange = (date) => {
    if (date < startDate) {
      showAlert(toast.TYPE.ERROR, AppConstant.reports.userRatings.endGreaterThanStartError, 'light')
      setIsError(true)
      // return;
      // setStartDate(date);
    } else if (calculateMonthDifference(startDate, date) > 2) {
      showAlert(toast.TYPE.ERROR, AppConstant.reports.userRatings.dateDiffGreaterThan12Months, 'light')
      setIsError(true)
      // return;
      // setStartDate(date);
    } else {
      setIsError(false)
    }
    date.setMonth(date.getMonth() + 1, 0);
    setEndDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
  };

  const handleWarehouseChange = (data) => {
    setIDWarehouse(data.ID);
  };

  /**
   * Used to download the user rating data
   * @param {*} type 
   */
  const downloadData = (type) => {
    const eDate = moment(endDate).hours(23).minutes(59).seconds(59)
    let payload = {
      fileType: type,
      rating: currentFilterSelected?.name === 'All' ? null : currentFilterSelected?.name,
      startDate: moment(startDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
      endDate: moment(eDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
      // warehouse_id: selectedWarehouse.ID,
      IDWarehouse: IDWarehouse ? IDWarehouse : null,
      fileName: "User-Ratings-" + userAccountDetails?.UserName,
    }
    dispatch({ type: sagaActions.USER_RATIING_DOWNLOAD, payload });
  }

  /**
   * Used to set the filtered rating details
   * @param {*} data 
   */
  const setCurrentFilterDetails = (data) => {
    setCurrentFilterSelected(data);

  }

  return (
    <>
      <div className='m-2 d-flex justify-content-between'>
        <div>
          <CustomButton
            disabled={view === 'T' ? true : false}
            isLoading={false}
            title={'Tabular'}
            className={`addButton mx-1 ${view === 'T' ? '' : 'disabledActionColor'}`}
            onClick={() => {
              dispatch({ type: sagaActions.RESET_USER_RATINGS_ACTION });
              setView('T')
            }}>Tabular</CustomButton>
          <CustomButton
            disabled={view === 'G' ? true : false}
            isLoading={false}
            title={'Graphical'}
            className={`addButton mx-1 ${view === 'G' ? '' : 'disabledActionColor'}`}
            onClick={() => {
              dispatch({ type: sagaActions.RESET_USER_RATINGS_ACTION });
              setView('G')
            }}
          >Graphical</CustomButton>
        </div>
        <DownloadSectionBE downloadData={downloadData} isDisabled={isError} ></DownloadSectionBE>
      </div>
      {view === 'T' ? <UserRatingsTabular {...props} view={view} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} handleStartYearChange={(d) => handleStartYearChange(d)} handleEndYearChange={(d) => handleEndYearChange(d)} handleStartDateChange={handleStartDateChange} handleEndDateChange={handleEndDateChange} isError={isError} setCurrentFilterDetails={setCurrentFilterDetails} handleWarehouseChange={handleWarehouseChange} /> : <UserRatingsGraphical {...props} view={view} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} handleStartYearChange={(d) => handleStartYearChange(d)} handleEndYearChange={(d) => handleEndYearChange(d)} handleStartDateChange={handleStartDateChange} handleEndDateChange={handleEndDateChange} isError={isError} handleWarehouseChange={handleWarehouseChange} />}
    </>
  );
}

export default UserRatingsWrapper;